import { Logger } from 'loglevel';

import { getPrefixedLogger, onLogInit } from './LogHelper';

export let workerLog: Logger;
onLogInit(() => { workerLog = getPrefixedLogger('worker', '#0094f5'); });
